// This globals file is used by Visid components
// already importing from @veneer/primitives - latest

import { createGlobalStyle } from 'styled-components';
import { primitives } from '@veneer/primitives';

const GlobalStyles = createGlobalStyle`
    h1, h2, h3, h4, p {
        margin: 0;
        padding: 0;
    }
`;

export default GlobalStyles;

const { breakpoint0, breakpoint1, breakpoint2, breakpoint3, breakpoint4 } =
  primitives.layout;
const breakpoint5 = 1920;

export const minMobile = ` @media (min-width: ${breakpoint0}px)`; // 480px
export const minTablet = ` @media (min-width: ${breakpoint1}px)`; // 768px
export const minDesktopXS = ` @media (min-width: ${breakpoint2}px)`; // 1024px
export const minDesktopSmall = ` @media (min-width: ${breakpoint3}px)`; // 1280px
export const minDesktopRegular = ` @media (min-width: ${breakpoint4}px)`; // 1536px
export const minDesktopLarge = ` @media (min-width: ${breakpoint5}px)`; // 1920px

export const { color, layout, typography } = primitives;

export const paddingDesktopRegular = `calc((100% - 1440px) / 2)`;
export const paddingDesktopLarge = `calc((100% - 1608px) / 2)`;
